import React from "react"
import { Spinner } from "react-bootstrap"
import { QueryResultType, Relevance, QuerySuggestionsMode } from "./constants"
import { getSampleIndexDetails } from "./exampleData/getSampleIndexDetails"
import { getSearchResults } from "./exampleData/getSearchResults"
import { AvailableFacetManager } from "./facets/AvailableFacetManager"
import { Facets } from "./facets/Facets"
import { SelectedFacetManager } from "./facets/SelectedFacetManager"
import {
  getAttributeTypeLookup,
  getDataSourceNameLookup,
} from "./facets/utils"
import Pagination from "./pagination/Pagination"
import ResultPanel from "./resultsPanel/ResultPanel"
import SearchBar from "./searchBar/SearchBar"
import _ from "lodash"
import { AvailableSortingAttributesManager } from "./sorting/AvailableSortingAttributesManager"
import { SelectedSortingAttributeManager } from "./sorting/SelectedSortingAttributeManager"
import { DEFAULT_SORT_ATTRIBUTE, SortOrderEnum } from "./sorting/constants"
import { isNullOrUndefined } from "./utils"
import styled from 'styled-components'

const Wrapper = styled.div`
  .bold-text {
    font-weight: bold;
  }

  .display-inline {
    display: inline-block;
  }

  .small-bottom-margin {
    margin-bottom: 0.5rem;
  }

  .small-right-margin {
    margin-right: 1rem;
  }

  .action-link {
    cursor: pointer;
    color: var(--blue) !important;
  }

  .center-align {
    text-align: center;
  }

  .small-left-padding {
    padding-left: 2rem;
  }

  /* search bar */

  .search-bar {
    width: 50% !important;
    left: 25%;
    padding-top: 2rem;
  }

  .search-button {
    border-right: 1px solid var(--green) !important;
    border-top: 1px solid var(--green) !important;
    border-bottom: 1px solid var(--green) !important;
    border-left: 1px solid var(--green) !important;
    background-color: white !important;
  }

  .search-container {
    display: flex;
  }

  .search-facet-container {
    width: 25%;
  }

  .search-result-container {
    width: 50%;
  }

  .results-section {
    color: black !important;
    position: relative;
  }

  .results-number {
    padding: 1.5rem;
    color: grey;
  }

  .empty-results {
    margin-top: 2rem;
  }

  .result-spinner {
    margin-top: 2rem;
  }

  .result-container {
    margin-bottom: 2rem;
  }

  .title {
    padding-bottom: 0.5rem;
  }

  .container-body {
    padding: 1rem;
    font-size: 15px;
  }

  .container-divider {
    border-top: 1px solid var(--green);
    height: 1px;
    padding: unset;
  }

  .result-footer {
    display: flex;
    align-self: flex-start;
    justify-self: flex-end;

    line-height: 1.2rem;
  }

  .footer-left-text {
    padding-top: 0.6rem;
    text-align: left;
    font-size: 12px;
  }

  .file-format-divider-wrapper {
    float: right;
    padding-top: 0.1rem;
  }

  .file-format-divider {
    display: inline-block;
    border-right: 1px solid var(--green);
    height: 1rem;

    padding-right: 0.5rem;
    margin-right: 0.5rem;
  }

  .feedback-buttons {
    display: flex;
    -ms-flex-item-align: end;
    align-self: flex-end;
    margin-left: auto;
  }

  .feedback-buttons img {
    padding-left: 1rem;
    height: 3rem;
  }

  .faq-title {
    padding: 1rem;
    font-size: 15px;
  }

  .faq-answer {
    padding-top: 0.5rem !important;
  }

  .expand-collapse {
    max-height: 30px;
    cursor: pointer;
    margin-right: 0.5rem;
    margin-top: -2px;
  }

  .document-results-section {
    padding-top: 1rem;
  }

  .card-title {
    color: grey;
    padding: 1rem 0 0 1rem;
  }

  .top-answer {
    color: yellow;
  }

  .page-number {
    cursor: pointer;
    margin-right: 1.5rem;
  }

  .pagination-section {
    text-align: center;
    font-size: 15px;
    padding-bottom: 2rem;
  }

  .arrow {
    max-height: 30px;
    margin-top: -2px;
    margin-right: 1rem;
  }

  .carousel-relative-wrapper {
    position: relative;

    .arrow-left {
      position: absolute;
      left: -1.5rem;
      top: calc(50% - 2rem);

      .arrow {
        padding: 0.5rem 0.5rem;
        margin-left: 0.5rem;

        svg {
          margin-top: -1rem;
          margin-left: 0.1rem;
        }
      }
    }

    .arrow-right {
      position: absolute;
      right: -2.5rem;
      top: calc(50% - 2rem);

      .arrow {
        padding: 0.5rem 0.75rem;
        margin-left: -3.5rem;

        svg {
          margin-top: -1rem;
        }
      }
    }

    .arrow {
      border: 1px solid #dcdfe4;
      border-radius: 50%;
      width: 2rem;
      height: 3rem;
      background: white;
      position: relative;
      cursor: pointer;

      &:hover svg * {
        stroke: #dcdfe4;
      }
    }

    .arrow {
      color: var(--blue) !important;
    }

    .result-item {
      flex: 1 0 100%;
      flex-basis: 100%;
    }

    .carousel-container {
      display: flex;
    }

    .carousel-wrapper {
      width: 100%;
      overflow: hidden;

      .offscreen {
        margin-left: 2000rem;
        margin-left: 101vw;
      }
    }
  }

  .kendra-carousel-indicators {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: -1rem !important;
    padding-bottom: 0.5rem;
    padding-left: 0rem;

    li {
      &:nth-of-type(n + 2) {
        margin-left: 9px;
      }
    }
  }

  .kendra-carousel-indicator {
    display: block;
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 50%;
    background-color: #b7b7b7;
    opacity: 0.15;
    transition: opacity 0.15s cubic-bezier(0.4, 0, 1, 1);

    &--active {
      opacity: 0.75;
    }
  }
`

export default class Search extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      dataReady: false,
      searchResults: {},
      topResults: [],
      faqResults: [],
      docResults: [],
      currentPageNumber: 1,
      queryText: "",
      error: undefined,
      attributeTypeLookup: undefined,
      availableFacets: AvailableFacetManager.empty(),
      selectedFacets: SelectedFacetManager.empty(),
      index: undefined,
      facetsOpen:
        (this.props.facetConfiguration &&
          this.props.facetConfiguration.facetPanelDefaultOpen) ??
        false,
      availableSortingAttributes: AvailableSortingAttributesManager.empty(),
      selectedSortingAttribute: SelectedSortingAttributeManager.default(),
      suggestionsEnabled: false,
    }
  }

  async componentDidMount() {
    const { indexId, kendra } = this.props

    if (kendra) {
      const listDataSourcePromise = this.listDataSources(kendra, indexId)
      const describeQuerySuggestionsConfigPromise = this.describeQuerySuggestionsConfig()

      try {
        // Create attribute type lookup from index
        const index = await kendra
          .describeIndex({
            Id: indexId,
          })
          .promise()

        this.setState({
          attributeTypeLookup: getAttributeTypeLookup(index),
          index: index,
        })

        // Get available sorting attributes from index meta data
        if (index.DocumentMetadataConfigurations) {
          this.setState({
            availableSortingAttributes: this.state.availableSortingAttributes.fromIndexMetadata(
              index.DocumentMetadataConfigurations
            ),
          })
        }

        // Create data source name lookup
        const dataSources = await listDataSourcePromise
        const qsConfig = await describeQuerySuggestionsConfigPromise
        this.setState({
          dataSourceNameLookup: getDataSourceNameLookup(dataSources),
          suggestionsEnabled: (qsConfig && qsConfig.Mode === QuerySuggestionsMode.ENABLED) ? true : false,
        })
      } catch (e) {
        this.setState({
          error: e,
        })
      }
    } else {
      // The SDK is not configured, use mock data
      this.setState({
        ...getSampleIndexDetails(),
      })
    }
  }

  listDataSources = async (
    kendra,
    indexId
  ) => {
    try {
      let listDsResponse = await kendra
        .listDataSources({
          IndexId: indexId,
        })
        .promise()

      const dataSources = listDsResponse.SummaryItems || []

      while (listDsResponse?.$response.hasNextPage()) {
        const nextPage = listDsResponse.$response.nextPage()
        if (nextPage) {
          listDsResponse = await nextPage.promise()
          if (listDsResponse?.SummaryItems) {
            dataSources.push(...listDsResponse.SummaryItems)
          }
        } else {
          listDsResponse = null
        }
      }

      return dataSources
    } catch (e) {
      this.setState({
        error: e,
      })
    }

    return null
  }

 getResultsHelper = async (
    queryText,
    pageNumber,
    filter
  ) => {
    this.setState({ dataReady: false })

    let results = getSearchResults(pageNumber, filter)

    const queryRequest = {
      IndexId: this.props.indexId,
      QueryText: queryText,
      PageNumber: pageNumber,
      AttributeFilter: filter ? filter : undefined,
    }

    const sortingAttribute = this.state.selectedSortingAttribute.getSelectedSortingAttribute()
    const sortingOrder = this.state.selectedSortingAttribute.getSelectedSortingOrder()

    if (sortingAttribute !== DEFAULT_SORT_ATTRIBUTE) {
      queryRequest.SortingConfiguration = {
        DocumentAttributeKey: sortingAttribute,
        SortOrder: sortingOrder
      }
    }

    if (this.props.kendra) {
      try {
        results = await this.props.kendra.query(queryRequest).promise()
      } catch (e) {
        this.setState({
          searchResults: {},
          topResults: [],
          faqResults: [],
          docResults: [],
          dataReady: true,
          error: e,
        })
        return
      }
    } else {
      console.error(
        "WARNING: No Kendra SDK instance provided, using dummy data"
      )
    }

    const tempTopResults = []
    const tempFAQResults = []
    const tempDocumentResults = []

    if (results && results.ResultItems) {
      results.ResultItems.forEach((result) => {
        if (!isNullOrUndefined(this.props.s3) && result.DocumentURI) {
          try {
            let res = result.DocumentURI.split("/")
            if (res[2].startsWith("s3")) {
              //The URI points to an object in an S3 bucket
              //Get presigned url from s3
              let bucket = res[3]
              let key = res[4]
              for (var i = 5; i < res.length; i++) {
                key = key + "/" + res[i]
              }
              let params = { Bucket: bucket, Key: key }
              let url = this.props.s3?.getSignedUrl("getObject", params)
              result.DocumentURI = url
            }
          } catch {
            // Just do nothing, so the documentURI are still as before
          }
        }
        switch (result.Type) {
          case QueryResultType.Answer:
            tempTopResults.push(result)
            break
          case QueryResultType.QuestionAnswer:
            tempFAQResults.push(result)
            break
          case QueryResultType.Document:
            tempDocumentResults.push(result)
            break
          default:
            break
        }
      })

      // Only update availableFacets in two situations:
      // 1. There is no filter
      // 2. There is filter and the updateAvailableFacetsWhenFilterChange flag is true
      if (
        !filter ||
        (filter &&
          this.props.facetConfiguration?.updateAvailableFacetsWhenFilterChange)
      ) {
        this.setState({
          availableFacets: AvailableFacetManager.fromQueryResult(results),
        })
      }

      this.setState({
        searchResults: results,
        topResults: tempTopResults,
        faqResults: tempFAQResults,
        docResults: tempDocumentResults,
        dataReady: true,
        error: undefined,
      })
    } else {
      this.setState({
        searchResults: {},
        topResults: tempTopResults,
        faqResults: tempFAQResults,
        docResults: tempDocumentResults,
        dataReady: true,
        error: undefined,
      })
    }
    this.setState({
      currentPageNumber: pageNumber,
      queryText: queryText,
    })
  }

  // When submitting query from search bar, reset facets and sorting attributes
  getResults = async (queryText, pageNumber = 1) => {
    this.setState(
      {
        selectedFacets: this.state.selectedFacets.clearAll(),
        selectedSortingAttribute: SelectedSortingAttributeManager.default(),
      },
      () => {
        this.getResultsHelper(queryText, pageNumber)
      }
    )
  }

  getResultsOnPageChanging = async (
    queryText,
    pageNumber = 1
  ) => {
    this.computeFilterAndReSubmitQuery(queryText, pageNumber)
  }

  submitFeedback = async (
    relevance,
    resultItem
  ) => {
    if (!this.props.kendra) {
      console.error(
        "WARNING: No Kendra SDK instance provided, submit feedback ignored"
      )

      return
    } else if (!this.props.indexId) {
      console.error(
        "WARNING: No Kendra Index Id provided, submit feedback ignored"
      )

      return
    }

    const queryResult = this.state.searchResults;
    if (relevance !== Relevance.Click) {
      // Explicit relevance feedback
      const feedbackRequest = {
        IndexId: this.props.indexId,
        QueryId: queryResult.QueryId,
        RelevanceFeedbackItems: [
          {
            RelevanceValue: relevance,
            ResultId: resultItem.Id,
          },
        ],
      }

      this.props.kendra.submitFeedback(feedbackRequest).promise()
    } else {
      // Click feedback
      const feedbackRequest = {
        IndexId: this.props.indexId,
        QueryId: queryResult.QueryId,
        ClickFeedbackItems: [
          {
            ClickTime: new Date(),
            ResultId: resultItem.Id,
          },
        ],
      }

      this.props.kendra.submitFeedback(feedbackRequest).promise()
    }
  }

  getQuerySuggestions = async (
    queryText
  ) => {
    const getQuerySuggestionsRequest = {
      IndexId: this.props.indexId,
      QueryText: queryText,
    }
    if (this.props.kendra) {
        const response = await this.props.kendra.getQuerySuggestions(getQuerySuggestionsRequest).promise()
        if (response) {
            return response.Suggestions
        }
    }
  }

  describeQuerySuggestionsConfig = async () => {
    const describeQuerySuggestionsConfigRequest = {
      IndexId: this.props.indexId,
    }
    if (this.props.kendra) {
        return await this.props.kendra.describeQuerySuggestionsConfig(describeQuerySuggestionsConfigRequest).promise()
    }
  }

  getErrorNotification = () => {
    return (
      <div className="error-div">
        {!_.isEmpty(this.state.error?.message)
          ? this.state.error?.message
          : this.state.error?.code}
      </div>
    )
  }

  computeFilterAndReSubmitQuery(
    queryText,
    pageNumber = 1
  ) {
    const filter = this.state.selectedFacets.buildAttributeFilter(
      this.state.attributeTypeLookup
    )

    this.getResultsHelper(queryText, pageNumber, filter)
  }

  onSelectedFacetsChanged = (updatedSelectedFacets) => {
    this.setState(
      {
        selectedFacets: updatedSelectedFacets,
      },
      () => {
        this.computeFilterAndReSubmitQuery(this.state.queryText)
      }
    )
  }

  handleClickExpander = () => {
    this.setState({
      ...this.state,
      facetsOpen: !this.state.facetsOpen,
    })
  }

  onSortingAttributeChange = (event) => {
    this.setState(
      {
        selectedSortingAttribute: this.state.selectedSortingAttribute.setSelectedSortingAttribute(
          event.currentTarget.value
        ),
      },
      () => {
        this.computeFilterAndReSubmitQuery(this.state.queryText)
      }
    )
  }

  onSortingOrderChange = (
    event
  ) => {
    const sortingOrder = this.state.selectedSortingAttribute.getSelectedSortingOrder()
    if (sortingOrder === SortOrderEnum.Desc) {
      this.setState(
        {
          selectedSortingAttribute: this.state.selectedSortingAttribute.setSelectedSortingOrder(
            SortOrderEnum.Asc
          ),
        },
        () => {
          this.computeFilterAndReSubmitQuery(this.state.queryText)
        }
      )
    } else if (sortingOrder === SortOrderEnum.Asc) {
      this.setState(
        {
          selectedSortingAttribute: this.state.selectedSortingAttribute.setSelectedSortingOrder(
            SortOrderEnum.Desc
          ),
        },
        () => {
          this.computeFilterAndReSubmitQuery(this.state.queryText)
        }
      )
    }
  }

  render() {
    return (
      <Wrapper>
        {this.state.error && this.getErrorNotification()}
        <SearchBar
            onSubmit={this.getResults}
            suggestionsEnabled={this.state.suggestionsEnabled}
            getQuerySuggestions={this.getQuerySuggestions}
        />
        {this.state.queryText && this.state.dataReady && (
          <div className="search-container">
            <div className="search-facet-container">
              <Facets
                availableFacets={this.state.availableFacets}
                attributeTypeLookup={this.state.attributeTypeLookup}
                dataSourceNameLookup={this.state.dataSourceNameLookup}
                onSelectedFacetsChanged={this.onSelectedFacetsChanged}
                selectedFacets={this.state.selectedFacets}
                index={this.state.index}
                open={this.state.facetsOpen}
                onExpand={this.handleClickExpander}
              />
            </div>
            <div className="search-result-container">
              {this.state.searchResults.TotalNumberOfResults === 0 && (
                <div className="empty-results center-align">
                  Kendra didn't match any results to your query.
                </div>
              )}
              {this.state.searchResults.TotalNumberOfResults !== 0 && (
                <div>
                  <ResultPanel
                    results={this.state.searchResults}
                    topResults={this.state.topResults}
                    faqResults={this.state.faqResults}
                    docResults={this.state.docResults}
                    dataReady={this.state.dataReady}
                    currentPageNumber={this.state.currentPageNumber}
                    submitFeedback={this.submitFeedback}
                    availableSortingAttributes={
                      this.state.availableSortingAttributes
                    }
                    selectedSortingAttribute={
                      this.state.selectedSortingAttribute
                    }
                    onSortingAttributeChange={this.onSortingAttributeChange}
                    onSortingOrderChange={this.onSortingOrderChange}
                  />
                  <Pagination
                    queryText={this.state.queryText}
                    currentPageNumber={this.state.currentPageNumber}
                    onSubmit={this.getResultsOnPageChanging}
                    results={this.state.searchResults}
                  />
                </div>
              )}
            </div>
          </div>
        )}

        {this.state.queryText && !this.state.dataReady && (
          <div className="results-section center-align">
            {/* <Spinner
              className="result-spinner"
              animation="border"
              variant="secondary"
            /> */}
          </div>
        )}
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Kendra/Search.js